/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import NavBar from '../../../components/NavBar';
import Form from '../UnitLayouts/Form';

class Edit extends Component {
  static propTypes = {
    token: PropTypes.string,
    id: PropTypes.string,
    unitLayoutID: PropTypes.string,
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    location: PropTypes.shape({
      hash: PropTypes.string,
    }),
    loading: PropTypes.bool,
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
    };
  }
  getFormInstance = () => {
    let form = this.form;
    while (form && form.getWrappedInstance) {
      form = form.getWrappedInstance();
    }
    return form;
  }
  async submit(validations, unitLayout) {
    const { store } = this.context;
    const { t } = this.props;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    let res;
    try {
      res = await this.getFormInstance().submit(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(unitLayout),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false);
    });
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: t('{{name}} successfully updated', { name: res.name, ns: TRANSLATION_FILES.translation }),
    }));
  }
  handleSubmit = (event) => {
    this.getFormInstance().handleSubmit(event);
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={`${t('Edit', { ns: TRANSLATION_FILES.translation })} ${this.props.data ? this.props.data.name : t('Layout').toLowerCase()}`}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Save', { ns: TRANSLATION_FILES.translation })}
                onClick={this.handleSubmit}
                disabled={!this.state.hasChanges}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, unitLayout) => {
            this.submit(validations, unitLayout);
          }}
          onChange={this.handleOnChange}
          projectID={this.props.id}
          location={this.props.location}
          loading={this.props.loading}
          unitLayout={this.props.data}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(Edit);



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/Edit.jsx